import { addHours } from 'date-fns'

/**
 * Retrieves the value of a cookie with the given name.
 * @param name - The name of the cookie to retrieve.
 * @returns The value of the cookie, or `undefined` if the cookie is not found.
 */
export function getCookie(name: string): string | undefined {
  const matches = document.cookie.match(
    new RegExp(
      `(?:^|; )${name.replace(
        /([.$?*|{}()[]\/+^])/g,
        '\\$1'
      )}=([^;]*)`
    )
  )
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

const stringifyValue = (val: string | Record<string, unknown>) => typeof val === 'string' ? val : JSON.stringify(val);

const bakeSessionCookie = (name: string, value: string | Record<string, unknown>, resolve: (value: boolean) => void): void => {
  const cookie = [name, '=', stringifyValue(value), ';expires=Session', '; path=/;'].join('');
  document.cookie = cookie;
  resolve(true);
}

const bakeCookie = (name: string, value: string | Record<string, unknown>, hours: number): void => {
  let date = new Date();
  date = addHours(date, hours); 
  const cookie = [name, '=', stringifyValue(value), ';expires', '=', date.toUTCString(), '; path=/;'].join('');
  document.cookie = cookie;
}

const ONE_MONTH_HOURS_COUNT = 30 * 1 * 24;

/**
 * Sets a cookie with the given name and value.
 * @param name - The name of the cookie to set.
 * @param val - The value to set the cookie to, which can be a string or an object.
 * @returns A Promise that resolves to `true` when the cookie has been set.
 */
export function setCookie(name: string, val: string | Record<string, unknown>): Promise<boolean> {
  // if (this.getCookie(name) ) return;
  return new Promise((resolve, reject) => {
    bakeSessionCookie(name, val, resolve);
  });
}

/**
 * Removes a cookie with the given name.
 * @param name - The name of the cookie to remove.
 */
export function clearCookie(name) {
  bakeCookie(name, '', -1)
}
